export default "__VITE_ASSET__3856c2d9__"